import { render, staticRenderFns } from "./live.vue?vue&type=template&id=c8281858&scoped=true"
import script from "./live.vue?vue&type=script&setup=true&lang=js"
export * from "./live.vue?vue&type=script&setup=true&lang=js"
import style0 from "./live.vue?vue&type=style&index=0&id=c8281858&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8281858",
  null
  
)

export default component.exports